import Analytics from '@opencare/analytics';
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { updateReasonNoMatch } from 'connect/actions';
import { StepHeader, StepHeaderSubtext, StepHeaderText } from 'pages/checkout/components/common/layout-styled-components';
import { selectOngoingCareNoMatch, selectReasonNoMatch } from 'pages/checkout/connect/legacy-selectors';
import { useNextCheckoutStep } from 'pages/checkout/hooks/checkoutStepHooks';
import { TreatmentSelector } from 'pages/funnel/components/ConcernsTreatment/TreatmentSelector';

import { useAnalyticsService } from 'services/AnalyticsService';

import { useEffectOnce } from 'utils/customHooks/useEffectOnce';

import { TreatmentsQuestionWrapper } from './styled-components';

const analytics = new Analytics();

export const TreatmentsQuestion = () => {
  const dispatch = useDispatch();
  const { goToNextStep } = useNextCheckoutStep();
  const analyticsService = useAnalyticsService();

  const savedAnswerOngoingCare = useSelector(selectOngoingCareNoMatch);
  const savedTreatments = useSelector(selectReasonNoMatch) || [];

  useEffectOnce(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.CHECKOUT,
      pageName: 'checkout-treatments',
      name: 'checkout',
      section: 'treatments',
      ...analyticsService.analyticsData,
    });
  });

  const onContinue = ({ selectedTreatments }: { selectedTreatments: string[]; }) => {
    analytics.trackForm({
      pageType: analytics.pageTypes.CHECKOUT,
      pageName: 'checkout-treatments',
      name: 'checkout',
      section: 'treatments',
      content: {
        treatments: selectedTreatments.join(','),
      },
    });

    dispatch(updateReasonNoMatch(selectedTreatments));
    goToNextStep();
  };

  return (
    <TreatmentsQuestionWrapper>
      <StepHeader>
        <StepHeaderText>
          Do you have any specific concerns or treatments you require?
        </StepHeaderText>
        <StepHeaderSubtext>
          We will ensure we match you with a dentist who has expertise in these areas,
          and provide them the information
        </StepHeaderSubtext>
      </StepHeader>

      <TreatmentSelector
        savedTreatments={savedTreatments}
        isOngoingSelected={savedAnswerOngoingCare === 'Yes'}
        onContinue={onContinue}
      />
    </TreatmentsQuestionWrapper>
  );
};
